class UI {
	static tips = UI.htm('div', 'tooltips-container');
	
	static htm() {
		return htm(...arguments);
	}

	static template(name) {
		return UI.div('', ge(name).content.cloneNode(true));
	}

	static list() {
		return UI.div(
			'grid grid-col-1 divide-x divide-grey-500',
			...arguments
		);
	}

	static listRow() {
		return UI.div(
			'ed-list-row flex flex-wrap min-h-12 px-5 gap-3 items-center border-t border-b mt-[-1px] bg-neutral-50 norm editing-off ', 
			...arguments
		);
	}

	static listPlace(content) {
		return UI.div(
			'absolute w-full',
			content
		)
	}

	static listHandle(cb) {
		return UI.div(
			'bg-[url("../images/sort-handle.png")] -ms-4 h-8 w-4',
			null,
			{'mousedown touchstart': cb}
		);
	}

	static listRowDrag() {

	}

	static img() {return img(...arguments);}

	static div() {
		return UI.htm('div', ...arguments);
	} 

	static span() {
		return UI.htm('span', ...arguments);
	}

	static h1() {
		return UI.htm('h1', ...arguments);
	}

	static p() {
		return UI.htm('p', ...arguments);
	}

	static a(contents, events, attributes) {
		return UI.loadTip(UI.htm('a', 'p-0', ...arguments));
	}

	static icon(name, size) {
		let i = document.createElementNS(xmlns, 'svg');
		let u = document.createElementNS(xmlns, 'use');
		i.setAttribute('height', size);
		i.setAttribute('width', size);
		i.setAttribute('fill', 'currentColor');
		u.setAttribute('href', `/images/icons.svg#icon-${name}`);
		i.appendChild(u);
		return i;
		// return `<svg height="${size}" width="${size}" fill="currentColor"><use href="/images/icons.svg#icon-${name}"/></svg>`;
	}

	static form() {
		return UI.htm(
			'form',
			'max-w-md mx-auto',
			...arguments
		);
	}

	static formRow() {
		return UI.div(
			'relative z-0 w-full mt-4 mb-4 group',
			...arguments
		);
	}

	static label(text, events, attributes) {
		return UI.htm(
			'label',
			'ed-label',
			text, 
			events,
			attributes
		);
	}

	static text(value, events, attributes) {
		return UI.loadTip(UI.input(
			'text',
			'ed-text',
			value,
			events,
			attributes
		));
	}

	static area(value, events, attr) {
		return UI.loadTip(UI.htm(
			'textarea',
			'ed-text',
			value,
			events,
			attr
		))
	}

	static select(options, events, attr) {
		return UI.loadTip(UI.htm(
			'select',
			'ed-text',
			options,
			events,
			attr
		))
	}

	static option(label, value) {
		let e = document.createElement('option');
		e.innerHTML = label;
		e.value = value;
		return e;
	}

	static textIl(value, events, attr) {
		return UI.loadTip(UI.input(
			'text',
			'',
			value,
			events,
			attr
		));
	}

	static pass(events, attributes) {
		return UI.input(
			'password',
			'ed-text',
			null,
			events,
			attributes
		);
	}

	static chk(value, events, attributes) {
		return UI.input(
			'checkbox',
			'',
			...arguments
		);
	}

	static styleChk(checkbox, events, attr) {
		checkbox.classList.add('sr-only', 'peer');
		return UI.loadTip(
			UI.htm(
				'label',
				'px-2 py-1',
				[
					checkbox,
					UI.div(
						'border h-4 w-4 text-transparent peer-checked:text-primary-600',
						UI.div('-mt-1.5 -ml-1', UI.icon('check', 26))
					)
				],
				events,
				attr
			)
		)
	}

	static iconChk(checkbox, iconName, iconSize, attributes) {
		checkbox.classList.add('sr-only', 'peer');
		return UI.loadTip(
			UI.htm(
				'label',
				'px-2 py-1',
				[
					checkbox,
					UI.div(
						'inline-block peer-checked:text-primary-600',
						UI.icon(iconName, iconSize)
					)
				],
				null,
				attributes
			)
		);
	}

	static toggle(checkbox, label, attributes) {
		checkbox.classList.add('sr-only', 'peer');
		return this.loadTip(
			UI.htm(
				'label',
				'inline-flex items-center cursor-pointer gap-3',
				[
					checkbox,
					UI.div(
						'relative w-11 h-6 bg-neutral-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[\'\'] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-neutral-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-secondary-700 peer-disabled:opacity-25'
					),
					label
				],
				null, 
				attributes
			)
		);
	}

	static btn(cNames, label, events) {
		return UI.loadTip(UI.htm(
			'button', ...arguments
		));
	}

	static priBtn(label, events) {
		return UI.htm(
			'button',
			'ed-pri-btn',
			...arguments
		);
	}

	static secBtn(label, events) {
		return UI.htm(
			'button',
			'ed-sec-btn',
			...arguments
		);
	}

	static priIconBtn(name, size, events, attributes) {
		return UI.loadTip(UI.htm(
			'button',
			'ed-pri-i-btn px-2 py-1 leading-none',
			UI.icon(name, size),
			...Array.prototype.slice.call(arguments, 2)
		));
	}

	static secIconBtn(name, size, events, attributes) {
		return UI.loadTip(UI.htm(
			'button',
			'ed-sec-i-btn px-2 py-1 leading-none',
			UI.icon(name, size),
			...Array.prototype.slice.call(arguments, 2)
		));
	}

	static popupTitle(contents) 
	{
		return UI.div(
			'w-full p-3 nowrap text-center font-bold',
			contents
		);
	}

	static popupItem(contents, events, attributes) {
		return UI.loadTip(UI.div(
			'flex items-center w-full py-2 px-3 text-zinc-900 nowrap hover:bg-primary-600 hover:text-white text-left',
			contents,
			events,
			attributes
		));
	}

	static popBtn(label, events, attr) {
		return UI.popupItem(UI.btn('h-full w-full', label, events, attr));
	}

	static inputGrp(inputs) {
		for (let i = 0, ii = inputs.length; i < ii; i++) {
			inputs[i].className = 'px-3 py-2 text-sm font-medium text-neutral-800 bg-transparent border-t border-b border-e border-neutral-300 hover:bg-secondary-700 hover:text-white';
			if (i == 0) inputs[i].classList.add('border-s', 'rounded-s-lg');
			if (i == ii - 1) inputs[i].classList.add('rounded-e-lg');
		}
		return UI.div(
			'inline-flex rounded-md shadow-sm',
			inputs
		);
	}

	static input(type, cNames, value, events, attributes) {
		return input(type, cNames, value, events, attributes);
	}

	static showToolTip() {
		if (typeof this.tooltip == 'undefined') {
			this.tooltip = UI.div(
				'tooltip-content',
				[
					UI.div(),
					this.getAttribute('aria-label')
				]
			);
			UI.tips.appendChild(this.tooltip);
		}
		
		let pos0 = this.getAttribute('data-tip') || 'above';
		let pos1 = findPos(pos0, this.tooltip, this, 8);
		let pos2 = findPos(pos0, null, this);
		
		this.tooltip.style.top = pos1.top + 'px';
		this.tooltip.style.left = pos1.left + 'px';
		this.tooltip.firstChild.style.top = pos2.top + 'px';
		this.tooltip.firstChild.style.left = pos2.left + 'px';
		this.tooltip.firstChild.style.transform = 'rotate(' + pos2.r + 'deg)'
		this.tooltip.style.visibility = 'visible';
		this.tooltip.style.opacity = 1;
	}
	
	static hideToolTip() {
		this.tooltip.style.visibility = 'hidden';
		this.tooltip.style.opacity = 0;
	}
	
	static loadTip(elem) {
		if (elem.hasAttribute('data-tip')) {
			onEv(elem, 'mouseover', UI.showToolTip);
			onEv(elem, 'mouseout', UI.hideToolTip);
		}
		return elem;
	}
}